import React, { useEffect, useState } from "react";
import { db, app } from "../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import css from "./foreignRights.module.css";

const storage = getStorage(app);

const AdminForeignRights = () => {
  const documentId = "uniqueForeignRight";
  const [data, setData] = useState({
    link: "",
    bannerTitle: "",
    bannerImage: "",
    bannerText: "",
    location: "",
    year: "",
    focus: "",
    bigImageTitle: "",
    titleText: "",
    descriptionText: "",
    bigImage: "",
    locationBlock: "",
    yearBlock: "",
    focusBlock: "",
  });

  const [loading, setLoading] = useState(true);
  const [newBannerFile, setNewBannerFile] = useState(null);
  const [newBigFile, setNewBigFile] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "foreignRights", documentId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setData((prev) => ({ ...prev, ...docSnap.data() }));
        }
      } catch (error) {
        console.error("Помилка при отриманні даних:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChange = (field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
  };

  const uploadImage = (file, path) => {
    return new Promise((resolve, reject) => {
      const storageRef = ref(storage, path);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        null,
        (error) => reject(error),
        () => {
          getDownloadURL(uploadTask.snapshot.ref)
            .then((url) => resolve(url))
            .catch((error) => reject(error));
        }
      );
    });
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const updatedData = { ...data };
      const uploadTasks = [];

      if (newBannerFile) {
        uploadTasks.push(
          uploadImage(newBannerFile, "foreignRights/bannerImage.jpg").then(
            (url) => {
              updatedData.bannerImage = url;
            }
          )
        );
      }

      if (newBigFile) {
        uploadTasks.push(
          uploadImage(newBigFile, "foreignRights/bigImage.jpg").then((url) => {
            updatedData.bigImage = url;
          })
        );
      }

      await Promise.all(uploadTasks);

      const docRef = doc(db, "foreignRights", documentId);
      await setDoc(docRef, updatedData);

      alert("✅ Дані успішно збережено");
    } catch (error) {
      console.error("❌ Помилка при збереженні:", error);
      alert("Сталася помилка при збереженні");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className={css.adminWrap}>Завантаження...</div>;

  return (
    <div className={css.adminWrap}>
      <h2 className={css.adminTitle}>Редагування Foreign Rights</h2>

      {/* === LINK === */}
      <label className={css.adminLabel}>🔗 Rights Guide Link:</label>
      <input
        type="text"
        className={css.adminInput}
        value={data.link}
        onChange={(e) => handleChange("link", e.target.value)}
      />

      {/* === BANNER === */}
      <h3 className={css.adminSubtitle}>📢 Банер</h3>

      <label className={css.adminLabel}>🏷 Заголовок у банері:</label>
      <input
        type="text"
        className={css.adminInput}
        value={data.bannerTitle}
        onChange={(e) => handleChange("bannerTitle", e.target.value)}
      />

      <label className={css.adminLabel}>📝 Banner Text:</label>
      <textarea
        className={css.adminTextarea}
        value={data.bannerText}
        onChange={(e) => handleChange("bannerText", e.target.value)}
      />

      <label className={css.adminLabel}>📍 Location:</label>
      <input
        type="text"
        className={css.adminInput}
        value={data.location}
        onChange={(e) => handleChange("location", e.target.value)}
      />

      <label className={css.adminLabel}>📅 Year:</label>
      <input
        type="text"
        className={css.adminInput}
        value={data.year}
        onChange={(e) => handleChange("year", e.target.value)}
      />

      <label className={css.adminLabel}>📚 Focus:</label>
      <textarea
        className={css.adminTextarea}
        value={data.focus}
        onChange={(e) => handleChange("focus", e.target.value)}
      />

      <label className={css.adminLabel}>🖼 Фото банера:</label>
      {data.bannerImage && (
        <img
          src={data.bannerImage}
          alt="banner"
          className={css.adminImagePreview}
        />
      )}
      <input
        type="file"
        className={css.adminFile}
        onChange={(e) => setNewBannerFile(e.target.files[0])}
      />

      {/* === BLOCK UNDER PHOTO === */}
      <h3 className={css.adminSubtitle}>📘 Блок під фото</h3>

      <label className={css.adminLabel}>🏷 Заголовок над фото:</label>
      <input
        type="text"
        className={css.adminInput}
        value={data.bigImageTitle}
        onChange={(e) => handleChange("bigImageTitle", e.target.value)}
      />

      <label className={css.adminLabel}>🎨 Title Text:</label>
      <textarea
        className={css.adminTextarea}
        value={data.titleText}
        onChange={(e) => handleChange("titleText", e.target.value)}
      />

      <label className={css.adminLabel}>📖 Description Text:</label>
      <textarea
        className={css.adminTextarea}
        value={data.descriptionText}
        onChange={(e) => handleChange("descriptionText", e.target.value)}
      />

      <label className={css.adminLabel}>🖼 Велике фото:</label>
      {data.bigImage && (
        <img src={data.bigImage} alt="big" className={css.adminImagePreview} />
      )}
      <input
        type="file"
        className={css.adminFile}
        onChange={(e) => setNewBigFile(e.target.files[0])}
      />

      {/* === BOTTOM BLOCK === */}
      <h3 className={css.adminSubtitle}>📍 Нижній блок</h3>

      <label className={css.adminLabel}>📌 Location:</label>
      <input
        type="text"
        className={css.adminInput}
        value={data.locationBlock}
        onChange={(e) => handleChange("locationBlock", e.target.value)}
      />

      <label className={css.adminLabel}>📌 Year:</label>
      <input
        type="text"
        className={css.adminInput}
        value={data.yearBlock}
        onChange={(e) => handleChange("yearBlock", e.target.value)}
      />

      <label className={css.adminLabel}>📌 Focus:</label>
      <textarea
        className={css.adminTextarea}
        value={data.focusBlock}
        onChange={(e) => handleChange("focusBlock", e.target.value)}
      />

      <button
        className={css.adminButton}
        onClick={handleSave}
        disabled={saving}
      >
        {saving ? "Збереження..." : "💾 Зберегти"}
      </button>
    </div>
  );
};

export default AdminForeignRights;
